import { TableColumn } from '@ibsys/kit';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { C1BotCandidateItem } from '@/entities/integrations';

/**
 * Колонки списка разговоров-кандидатов на загрузку диалогов голосового бота.
 */
export const useC1BotCandidateColumns = (): TableColumn<C1BotCandidateItem>[] => {
  const { t } = useTranslation(['integrations']);

  return useMemo(
    () => [
      {
        accessorKey: 'sessionId',
        header: () => <span>{t('integrations:c1Bot.candidates.table.sessionId')}</span>,
        size: 220,
        cell: ({ row }) => <span className="font-mono text-sm">{row.original.sessionId}</span>,
      },
      {
        accessorKey: 'callerPhone',
        header: () => <span>{t('integrations:c1Bot.candidates.table.callerPhone')}</span>,
        size: 150,
        cell: ({ row }) => <span className="font-mono text-sm">{row.original.callerPhone ?? ''}</span>,
      },
      {
        accessorKey: 'scriptType',
        header: () => <span>{t('integrations:c1Bot.candidates.table.scriptType')}</span>,
        size: 140,
        cell: ({ row }) => <span className="text-sm">{row.original.scriptType ?? ''}</span>,
      },
      {
        accessorKey: 'startedAt',
        header: () => <span>{t('integrations:c1Bot.candidates.table.startedAt')}</span>,
        size: 180,
        cell: ({ row }) => (
          <span className="text-sm">
            {row.original.startedAt ? new Date(row.original.startedAt).toLocaleString() : ''}
          </span>
        ),
      },
      {
        accessorKey: 'endedAt',
        header: () => <span>{t('integrations:c1Bot.candidates.table.endedAt')}</span>,
        size: 180,
        cell: ({ row }) => (
          <span className="text-sm">{row.original.endedAt ? new Date(row.original.endedAt).toLocaleString() : ''}</span>
        ),
      },
    ],
    [t],
  );
};
